import { NgModule } from '@angular/core';

import { SharedModule } from '@digiwall/goliath-core';
import { ServiceWorkOrderRoutingModule } from './service-work-order-routing.module';

@NgModule({
  declarations: [],
  imports: [SharedModule, ServiceWorkOrderRoutingModule],
})
export class ServiceWorkOrderModule {}
